module.exports = __webpack_public_path__ + "img/about-elevate-wellness.935cac35.png";